export default __webpack_public_path__ + "static/media/logo-metis.868ade6c.svg";